import type { ApiResponse } from "@/types/common";
import type { PlatformSettingsDto, PlatformSettingsUpdateDto } from "@/types/settings.dto";
import type {
  EmailSettingsDto,
  EmailSettingsUpdateDto,
  EmailStatsDto,
  EmailTestRequestDto,
  IntegrationSettingsDto,
  IntegrationSettingsUpdateDto,
} from "@/types/integration.dto";
import { apiClient, unwrapApiResponse } from "./httpClient";

export const settingsService = {
  getPlatformSettings(): Promise<PlatformSettingsDto> {
    return unwrapApiResponse(apiClient.get<ApiResponse<PlatformSettingsDto>>("/Settings/platform"));
  },

  updatePlatformSettings(dto: PlatformSettingsUpdateDto): Promise<PlatformSettingsDto> {
    return unwrapApiResponse(apiClient.put<ApiResponse<PlatformSettingsDto>>("/Settings/platform", dto));
  },

  getEmailSettings(): Promise<EmailSettingsDto> {
    return unwrapApiResponse(apiClient.get<ApiResponse<EmailSettingsDto>>("/Settings/email"));
  },

  updateEmailSettings(dto: EmailSettingsUpdateDto): Promise<EmailSettingsDto> {
    return unwrapApiResponse(apiClient.put<ApiResponse<EmailSettingsDto>>("/Settings/email", dto));
  },

  getEmailStats(): Promise<EmailStatsDto> {
    return unwrapApiResponse(apiClient.get<ApiResponse<EmailStatsDto>>("/Settings/email/stats"));
  },

  sendTestEmail(dto: EmailTestRequestDto): Promise<boolean> {
    return unwrapApiResponse(apiClient.post<ApiResponse<boolean>>("/Settings/email/test", dto));
  },

  getIntegrationSettings(): Promise<IntegrationSettingsDto> {
    return unwrapApiResponse(apiClient.get<ApiResponse<IntegrationSettingsDto>>("/Settings/integrations"));
  },

  updateIntegrationSettings(dto: IntegrationSettingsUpdateDto): Promise<IntegrationSettingsDto> {
    return unwrapApiResponse(apiClient.put<ApiResponse<IntegrationSettingsDto>>("/Settings/integrations", dto));
  },
};
